/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../../../../../common/graphql/generated/types';

export type SubscriptionButton_OrganizationFragment = { id: any };

export const SubscriptionButton_OrganizationFragmentDoc = `
    fragment SubscriptionButton_Organization on Organizations {
  id
}
    `;